export default {
  DUPLICATE_EMAIL: 'DUPLICATE_EMAIL',
};
